const menuBtn = document.getElementById('header_btn_search-custom');
const sidebar = document.getElementById('sidebar');
const closeBtn = document.getElementById('closeBtn');
const overlay = document.getElementById('overlay-search');
const bodyEle = document.querySelector('body');

menuBtn.addEventListener('click', () => {
    sidebar.classList.add('active-search');
    overlay.classList.add('active-search');
    bodyEle.style.overflow = 'hidden'
});

closeBtn.addEventListener('click', () => {
    sidebar.classList.remove('active-search');
     overlay.classList.remove('active-search');
});

overlay.addEventListener('click', () => {
    sidebar.classList.remove('active-search');
    overlay.classList.remove('active-search');
    bodyEle.style.overflow = 'auto';
});